// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"ebdfe0977115e026","5285":"0946b25946f994ee"}[chunkId] + ".css";
};